import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { PriceModifierType } from 'src/items-list/business-logic/service/interfaces/line-item-add.dto';
import { AbortedError, ProhibitActionError } from '../../common/api/extended-emerald-error';
import { popEmeraldModal } from '../../common/emerald-modal-manager/emerald-modal-manager';
import { PriceEntryType } from '../../common/enumerations/price-entry-type';
import { IItemDetails } from '../../common/interfaces/dtos/IItemDetails';
import { addLineItemToTransaction } from '../../home-page/business-logic/sale-mode-router';
import { ILineItemAddData } from '../../items-list/business-logic/line-item-add';
import { popupMessage } from '../../messages/business-logic/popup-message';
import {
  PRICE_VERIFICATION_MODAL,
  showPriceVerificationDialog,
} from '../components/price-verification-modal';
import { handlePriceEntryExceptions } from './handle-price-entry-actions';

export const handlePriceVerifyRequiredExceptions = (
  priceEntryType: PriceEntryType,
  lineItemData: ILineItemAddData,
  itemDetails: IItemDetails,
): Promise<void> => {
  const span = createSpan('handle-error-user-input');
  return new Promise<void>((resolve, reject) => {
    const onAccept = async (): Promise<void> => {
      endSpan(span);
      lineItemData.lineItem.newPrice = Number(itemDetails.price);
      lineItemData.lineItem.modifiers = ['PriceOverride'];
      lineItemData.lineItem.priceModifierType = PriceModifierType.PriceVerify;
      await addLineItemToTransaction(lineItemData)
        .then(resolve)
        .catch(err => {
          if (err instanceof AbortedError || err instanceof ProhibitActionError) {
            reject(err);
          } else {
            popupMessage(err);
          }
        });
      popEmeraldModal(PRICE_VERIFICATION_MODAL);
    };

    const onReject = (): void => {
      endSpan(span);
      popEmeraldModal(PRICE_VERIFICATION_MODAL);
      handlePriceEntryExceptions(PriceEntryType.PriceVerify, lineItemData, itemDetails)
        .then(resolve)
        .catch(err => reject(err));
    };

    showPriceVerificationDialog({
      onReject,
      onAccept,
      itemDetails,
      priceEntryType,
    });
  });
};

export const getUnitsOfMeasure = (itemDetails: IItemDetails): string => {
  switch (itemDetails.unitsOfMeasure) {
    case 'UOM_EA':
      return itemDetails.quantity > 1 ? 'UOMS_' : 'UOM_EA';
    default:
      return itemDetails.unitsOfMeasure || '';
  }
};

export const getQuantity = (itemDetails: IItemDetails): string => {
  switch (itemDetails.unitsOfMeasure) {
    case 'UOM_EA':
      return `${itemDetails.quantity.toString()} `;
    default:
      return '';
  }
};
